import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  // Получение всех констант для перевода
  getTranslations () {
    axios.defaults.baseURL = process.env.VUE_APP_BACK_URL

    return axios.get('/ru/api/public/translations')
  },
  // Получение данных для формы страницы "Аналитика (сводные отчеты по численности)"
  getAnimalAccountingFaunasYearFormData () {
    return axios.get(`${i18n.locale}/api/public/getAnimalAccountingFaunasYearFormData`)
  },
  // Список данных для страницы "Аналитика (сводные отчеты по численности)"
  getAnimalAccountingFaunasYearData (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/public/getAnimalAccountingFaunasYearData?${filter}`)
  },
  // печать в ворд аналитики
  printCountSummaryReport (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/public/printCountSummaryReport/?${filter}`, { responseType: 'arraybuffer' })
  },
  // список участков для рекр. зоны
  getRecreationalPlots () {
    return axios.get(`${i18n.locale}/api/public/recreationalPlots`)
  }
}
